import React, { useState, useEffect } from 'react';
import { Tabs } from 'antd';
import s from './s.module.less';
import PracticeFront from 'pages/dashboard/PracticeFrontPage';
import ChannelMainPage from 'pages/dashboard/ChannelMainPage';

interface ExternalMarketingProps {
    defaultSubTab?: string | null;
}

const ExternalMarketing: React.FC<ExternalMarketingProps> = ({ defaultSubTab }) => {
    const [tabKey, setTabKey] = useState('channel');

    const tabItems = [
        {
            key: 'channel',
            label: 'Channel',
            children: <ChannelMainPage />,
        },
        {
            key: 'practice-front',
            label: 'Practice front',
            children: <PracticeFront />,
        },
    ];

    // 根据 defaultSubTab 设置初始选中的 tab
    useEffect(() => {
        if (defaultSubTab) {
            const validSubTabs = tabItems.map((item) => item.key) as string[];
            if (validSubTabs.includes(defaultSubTab)) {
                setTabKey(defaultSubTab);
            }
        }
    }, [defaultSubTab]);

    const handleTabClick = (key: string) => {
        setTabKey(key);
    };

    return (
        <div className={s.wrap}>
            <Tabs activeKey={tabKey} items={tabItems} onTabClick={handleTabClick} />
        </div>
    );
};

export default ExternalMarketing;
